export default "__VITE_ASSET__xA$1N82D__"